'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['SettingsRestService', '$q',
                function(SettingsRestService, $q) {
                    let _settings = {};

                    // Настройка фильтра для этапа поддержки.
                    const PROJECT_SUPPORT_STAGE_DEFAULT_FILTER = 'PROJECT_SUPPORT_STAGE_DEFAULT_FILTER';

                    return {
                        getValueByType: getValueByType,
                        setValueForType: setValueForType,
                        getAvailableValuesByType: getAvailableValuesByType,
                        PROJECT_SUPPORT_STAGE_DEFAULT_FILTER: PROJECT_SUPPORT_STAGE_DEFAULT_FILTER,
                    };

                    // region Function
                    function getValueByType(type) {
                        return $q(function(resolve, reject) {
                            if (_settings[type]) {
                                resolve(_settings[type]);
                            } else {
                                SettingsRestService.getValueByType({type: type}, (data) => {
                                    _settings[type] = data['value'];
                                    resolve(data['value']);
                                });
                            }
                        });
                    }

                    function setValueForType(type, value) {
                        return $q(function(resolve, reject) {
                            return SettingsRestService.setValueForType({value: value}, (data) => {
                                _settings[type] = value;
                                resolve(data);
                            });
                        });
                    }

                    function getAvailableValuesByType(type) {
                        return $q(function(resolve, reject) {
                            SettingsRestService.getAvailableValuesByType({type: type}, (data) => {
                                resolve(data['items']);
                            });
                        });
                    }

                    // endregion
                }];
